export enum HealthCheckUpStatusEnum {
  Ok = 0,
  Error = 1
}
